import React from 'react';
import PropTypes from 'prop-types';

import EventIcon from 'core/gd-components/icons/event/event-icon'
import EventModel from 'core/gd-model/event/event';
import SelectUser from "core/gd-ui/select-user/select-user";
import FormError from 'src/core/gd-form/common/form-error/form-error';
import TaskTypeIcon from "../../../../gd-components/icons/task-icon/task-icon";

export default class ReassignUserEvents extends React.Component {
    static propTypes = {
        form: PropTypes.object,

        projectId: PropTypes.string,
        userId: PropTypes.string,
        events: PropTypes.array,
    };

    renderEventsList = () => {
        let res = [];
        _.map(this.props.events, (event,key)=>{
            const project = event.projectId ? gd.session.projects.get(event.projectId) : null;

            const eventModel = new EventModel(event,{parse:true});

            // <div className="cell align-r">
            //     {project && <div className="ui5-property">{project.name}</div>}
            // </div>

            res.push(
                <div key={key} className="row">
                    <div className="cell">
                        <EventIcon className="ui5-ico-13 m-r-10" event={eventModel} hint={false} />
                        <div className="ui5-txt-default max-w-300">{event.name}</div>
                    </div>
                </div>
            )
        });

        // const userOptions = gd.session.projectUsers.filterByProject(this.props.projectId).exportToArrayUserId();
        const userOptions = gd.session.projectUsers.filterByProjectNotReadOnly(this.props.projectId).exportToArrayUserId();
        _.remove(userOptions, o=>o === this.props.userId);

        return (
            <React.Fragment>
                <div className="ui5-list h-40">
                    {res}
                </div>

                <div className="ra-to">
                    <div className="lbl">Re-assign to:</div>
                    <SelectUser form={this.props.form}
                                name="eventsReassignTo"
                                renderValue="form-icon-name"
                                options={userOptions}/>
                    <div className="lbl"/>
                </div>

                <FormError className="block-error" form={this.props.form} name="eventsReassignTo" />
            </React.Fragment>
        )
    };

    render() {
        let content;

        if (this.props.events.length>0) {
            content = this.renderEventsList();
        } else {
            return false
            // content = (
            //     <div className="block disabled ui5-txt-no-accent-small">
            //         No assigned events found.
            //     </div>
            // )
        }

        return (
            <div className="block">
                <div className="ui5-title-small m-t-20 m-b-10">
                    Events
                </div>
                {content}
            </div>
        )
    }
}